import React from "react";

import styled from "@emotion/styled";

import cls from "../../../utils/cls";
import Container from "../Container";
import Margin from "../Margin";

const Background = styled.div`
    animation: fadeIn 0.5s;
    background-color: rgba(0, 0, 0, 0.6);
    bottom: 0;
    left: 0;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 99;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }

        to {
            opacity: 1;
        }
    }
`;

const OverlayWrapper = styled.div`
    animation: slideIn 0.5s;
    bottom: 55px;
    left: 10px;
    position: fixed;
    right: 10px;
    top: 85px;
    z-index: 100;

    @keyframes slideIn {
        0% {
            top: -100vh;
        }

        80% {
            top: 90px;
        }

        100% {
            top: 75px;
        }
    }
`;

const OverlayBox = styled(Container)`
    background-color: hsl(0, 0%, 100%);
    border-radius: 6px;
    box-shadow: 0 -5px 5px 0 rgba(0, 0, 0, 0.2);

    display: flex;
    flex-direction: column;
    max-height: 100%;
    padding: 15px;
    width: 100%;
`;

const Content = styled.div`
    overflow: auto;

    /* This solves a strange bug on Chrome where the scroll bar appears although there is enough space. */
    padding-bottom: 1px;

    &.showOverflow {
        overflow: visible;
    }
`;

const ButtonWrapper = styled(Margin)`
    display: flex;
    flex-shrink: 0;

    justify-content: space-between;

    &.singleChild {
        justify-content: center;
    }
`;

const Overlay = ({ children, visible = false, boxClassName = null }) => {
    if (!visible) {
        return null;
    }

    return (
        <React.Fragment>
            <Background></Background>
            <OverlayWrapper>
                <OverlayBox ultraSlim className={boxClassName}>
                    {children}
                </OverlayBox>
            </OverlayWrapper>
        </React.Fragment>
    );
};

const OverlayContent = ({ children, showOverflow = false }) => (
    <Content className={cls(showOverflow && "showOverflow")}>
        {children}
    </Content>
);
Overlay.Content = OverlayContent;

const Buttons = ({ children }) => (
    <ButtonWrapper
        top="20"
        className={cls(
            React.Children.count(children) === 1 && "singleChild"
        )}
    >
        {children}
    </ButtonWrapper>
);
Overlay.Buttons = Buttons;

export default Overlay;
